import { useRefreshOnFocus } from "@/hooks/useRefreshOnFocus";
import { fetchPassesForSale } from "@/services/passesforsale.queries";
import { useToastNotify } from "@/stores/toastStore";
import { useQuery } from "@tanstack/react-query";
import { t } from "@transifex/native";

export const usePassesForSale = () => {
  const { notify } = useToastNotify();

  const { data, isPending, isFetching, isLoading, isError, error, refetch } = useQuery({
    queryKey: ["passesForSale"],
    queryFn: fetchPassesForSale,
  });

  if (isError) {
    notify({
      severity: "error",
      message: t("An error occurred when fetching passes for sale data"),
    });
    console.error("Error fetching passes for sale data:", error);
  }

  useRefreshOnFocus(refetch);

  return {
    passesForSale: data?.passesForSale,
    isPending,
    isFetching,
    isLoading,
  };
};
